export default "__VITE_ASSET__4621a97a__"